module.exports = __webpack_public_path__ + "static/img/sn.eed2f853.svg";